import { Close } from '@carbon/icons-react';
import { Button } from '@routable/components';
import clsx from 'clsx';
import React from 'react';
const CloseButton = ({ onClick, className }) => (React.createElement(Button, { className: clsx('close-btn', className), "data-testid": "close-button", intent: "primary", onPress: onClick, size: "small", variant: "floating" },
    React.createElement(Close, { className: "fill-grey-70", "data-testid": "close-button--icon", size: 16 })));
export default CloseButton;
